import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
// Veri kaynağı değiştirildi: routesData kullanılıyor
import { iller, ilceler, tumMekanlar } from '../components/routesData'; 
import {
    TextField, Autocomplete, CircularProgress, Button, Modal, Box, Typography,
    Card, IconButton, Divider
} from '@mui/material';

// Icons
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'; // Yeni İkon
import CloseIcon from '@mui/icons-material/Close'; // Yeni İkon
import LocationOnIcon from '@mui/icons-material/LocationOn'; // Süsleme için

// --- API Adresi ---
const API_URL = process.env.REACT_APP_API_URL;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#1f2937', // Gray-800
    border: '1px solid #374151', // Gray-700
    boxShadow: 24,
    p: 4,
    borderRadius: '16px',
    color: 'white',
    outline: 'none'
};

// Bilgilendirme Modalı için biraz daha geniş stil
const infoModalStyle = {
    ...modalStyle,
    width: 600,
    maxWidth: '90%',
};

// Input Stilleri
const inputStyles = {
    '& .MuiOutlinedInput-root': {
        color: 'white', 
        backgroundColor: '#1f2937',
        '& fieldset': { borderColor: '#4b5563' },
        '&:hover fieldset': { borderColor: '#9ca3af' },
        '&.Mui-focused fieldset': { borderColor: '#2dd4bf' },
    },
    '& .MuiInputLabel-root': { color: '#9ca3af' },
    '& .MuiInputLabel-root.Mui-focused': { color: '#2dd4bf' }
};

const YeniRotaOlusturSayfasi = () => {
    const navigate = useNavigate();

    // Rota Bilgileri State'leri
    const [rotaAdi, setRotaAdi] = useState('');
    const [rotaAciklamasi, setRotaAciklamasi] = useState('');
    const [ortalamaSure, setOrtalamaSure] = useState('');
    const [nelerOgreneceksinizText, setNelerOgreneceksinizText] = useState('');

    // Görsel Yükleme State'leri
    const [rotaGorseliFile, setRotaGorseliFile] = useState(null);
    const [rotaGorseliPreview, setRotaGorseliPreview] = useState(null);
    const [yuklenenGorselUrl, setYuklenenGorselUrl] = useState('');

    // Mekan Ekleme State'leri
    const [secilenIl, setSecilenIl] = useState('');
    const [secilenIlce, setSecilenIlce] = useState('');
    const [mevcutIlceler, setMevcutIlceler] = useState([]);
    const [arananMekanAdi, setArananMekanAdi] = useState('');
    const [arananMekanBilgi, setArananMekanBilgi] = useState('');
    const [arananMekanLat, setArananMekanLat] = useState('');
    const [arananMekanLon, setArananMekanLon] = useState('');
    const [eklenenMekanlar, setEklenenMekanlar] = useState([]);
    const [filtreliMekanOnerileri, setFiltreliMekanOnerileri] = useState([]);
    const [secilenMekanObj, setSecilenMekanObj] = useState(null);

    // Yükleme ve Hata Durumları
    const [formYukleniyor, setFormYukleniyor] = useState(false);
    const [formHata, setFormHata] = useState(null);

    // Modal State'leri
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState({ title: '', message: '' });
    const [isSuccessModal, setIsSuccessModal] = useState(false);

    // **YENİ: Bilgilendirme Modalı State'i**
    const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

    // Kullanıcı ID'sini token'dan alma
    const getUserIdFromToken = () => {
        const token = localStorage.getItem('token');
        if (!token) return null;
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            return payload.user_id;
        } catch (e) {
            console.error("Token decode hatası:", e);
            return null;
        }
    };
    const currentUserId = getUserIdFromToken();

    // İl seçimi değiştiğinde ilçe listesini güncelle
    useEffect(() => {
        if (secilenIl) {
            setMevcutIlceler(ilceler[secilenIl] || []);
            setSecilenIlce('');
        } else {
            setMevcutIlceler([]);
            setSecilenIlce('');
        }
    }, [secilenIl]);

    // Görsel seçildiğinde önizleme oluştur
    useEffect(() => {
        if (rotaGorseliFile) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setRotaGorseliPreview(reader.result);
            };
            reader.readAsDataURL(rotaGorseliFile);
        } else {
            setRotaGorseliPreview(null);
        }
    }, [rotaGorseliFile]);

    // İl ve ilçe seçimine göre mekan önerilerini filtrele
    useEffect(() => {
        let filtrelenmis = tumMekanlar;
        if (secilenIl) {
            filtrelenmis = filtrelenmis.filter(mekan => mekan.il === iller.find(il => il.id === secilenIl)?.name);
        }
        if (secilenIlce) {
            filtrelenmis = filtrelenmis.filter(mekan => mekan.ilce === mevcutIlceler.find(ilce => ilce.id === secilenIlce)?.name);
        }
        setFiltreliMekanOnerileri(filtrelenmis);
    }, [secilenIl, secilenIlce, mevcutIlceler]);

    // Autocomplete'ten mekan seçimi olduğunda inputları doldur
    useEffect(() => {
        if (secilenMekanObj) {
            setArananMekanAdi(secilenMekanObj.ad);
            setArananMekanBilgi(secilenMekanObj.bilgi || secilenMekanObj.aciklama_bolumleri?.[0]?.icerik || '');
            setArananMekanLat(String(secilenMekanObj.latitude || ''));
            setArananMekanLon(String(secilenMekanObj.longitude || ''));
            
            // Mekanın il isminden ID'sini bul
            const selectedIlId = iller.find(il => il.name === secilenMekanObj.il)?.id || '';
            setSecilenIl(selectedIlId);

            if (selectedIlId) {
                const correspondingIlces = ilceler[selectedIlId] || [];
                setMevcutIlceler(correspondingIlces);
                // Mekanın ilçe isminden ID'sini bul
                const selectedIlceId = correspondingIlces.find(ilce => ilce.name === secilenMekanObj.ilce)?.id || '';
                setSecilenIlce(selectedIlceId);
            }
        }
    }, [secilenMekanObj]);

    // Modal'ı açmak için genel fonksiyon (Success/Error)
    const openModal = (title, message, isSuccess) => {
        setModalContent({ title, message });
        setIsSuccessModal(isSuccess);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        if (isSuccessModal) {
            navigate('/route');
        }
    };

    const handleMekanEkle = () => {
        const mekanAdi = arananMekanAdi.trim();
        if (mekanAdi === '') {
            openModal("Uyarı", "Lütfen mekan adı girin.", false);
            return;
        }

        const isDuplicate = eklenenMekanlar.some(mekan => mekan.ad.toLowerCase() === mekanAdi.toLowerCase());
        if (isDuplicate) { 
            openModal("Uyarı", "Bu mekan zaten listeye eklenmiş.", false); 
            return; 
        }

        const newMekan = {
            id: Date.now(),
            ad: mekanAdi,
            bilgi: arananMekanBilgi.trim() || 'Ek bilgi yok.',
            il: iller.find(il => il.id === secilenIl)?.name || 'Bilinmiyor',
            ilce: mevcutIlceler.find(ilce => ilce.id === secilenIlce)?.name || 'Bilinmiyor',
            latitude: arananMekanLat ? parseFloat(arananMekanLat) : null,
            longitude: arananMekanLon ? parseFloat(arananMekanLon) : null,
        };
        setEklenenMekanlar([...eklenenMekanlar, newMekan]);

        setArananMekanAdi('');
        setArananMekanBilgi('');
        setArananMekanLat('');
        setArananMekanLon('');
        setSecilenMekanObj(null);
    };

    const handleMekanKaldir = (idToRemove) => {
        setEklenenMekanlar(eklenenMekanlar.filter(mekan => mekan.id !== idToRemove));
    };

    const handleRotayiKaydet = async (e) => {
        e.preventDefault();
        setFormYukleniyor(true);
        setFormHata(null);

        if (!currentUserId) {
            openModal("Hata", "Rota oluşturmak için lütfen giriş yapın.", false);
            setFormYukleniyor(false);
            navigate('/login');
            return;
        }

        if (!rotaAdi || !rotaAciklamasi || eklenenMekanlar.length === 0) {
            openModal("Hata", "Lütfen rota adı, açıklaması girin ve en az bir mekan ekleyin.", false);
            setFormYukleniyor(false);
            return;
        }

        const token = localStorage.getItem('token');
        if (!token) {
            openModal("Hata", "Token bulunamadı. Lütfen giriş yapın.", false);
            setFormYukleniyor(false);
            navigate('/login');
            return;
        }

        let finalGorselUrl = '';

        if (rotaGorseliFile) {
            const formData = new FormData();
            formData.append('file', rotaGorseliFile);
            try {
                const uploadResponse = await axios.post(`${API_URL}/api/upload-image/`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${token}` }
                });
                finalGorselUrl = uploadResponse.data.url;
                setYuklenenGorselUrl(finalGorselUrl);
            } catch (uploadError) {
                openModal("Hata", "Görsel yüklenirken hata oluştu: " + (uploadError.response?.data?.detail || uploadError.message), false);
                setFormYukleniyor(false);
                return;
            }
        } else if (yuklenenGorselUrl) {
            finalGorselUrl = yuklenenGorselUrl;
        }

        const icerdigiYapilarArray = eklenenMekanlar.map(mekan => mekan.ad);
        const nelerOgreneceksinizArray = nelerOgreneceksinizText.split('\n').filter(item => item.trim() !== '');

        const newRotaData = {
            baslik: rotaAdi,
            aciklama: rotaAciklamasi,
            ortalamaSure: ortalamaSure,
            gorsel: finalGorselUrl || null,
            icerdiğiYapılar: icerdigiYapilarArray,
            mekanDetaylari: eklenenMekanlar.map(mekan => ({
                ad: mekan.ad,
                bilgi: mekan.bilgi,
                il: mekan.il,
                ilce: mekan.ilce,
                latitude: mekan.latitude,
                longitude: mekan.longitude
            })),
            nelerOgreneceksiniz: nelerOgreneceksinizArray,
            il: eklenenMekanlar[0]?.il,
            ilce: eklenenMekanlar[0]?.ilce,
            is_public: false
        };

        try {
            await axios.post(`${API_URL}/rotalar`, newRotaData, {
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
            });
            openModal("Başarılı", "Rotanız başarıyla oluşturuldu!", true);
        } catch (error) {
            openModal("Hata", 'Rota kaydedilirken bir hata oluştu: ' + (error.response?.data?.detail || error.message), false);
            if (error.response && error.response.status === 401) {
                navigate('/login');
            }
        } finally {
            setFormYukleniyor(false);
        }
    };

    const handleIptal = () => {
        navigate('/route');
    };

    return (
        <div className="min-h-screen bg-gray-900 text-white p-4 md:p-8">
            <div className="max-w-4xl mx-auto">
                
                {/* --- Üst Bar ve Butonlar --- */}
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
                    {/* Sol Taraf: Buton Grubu */}
                    <div className="flex gap-3">
                        <Button 
                            onClick={() => navigate('/route')} 
                            variant="outlined" 
                            startIcon={<ArrowBackIcon />} 
                            className="text-gray-400 border-gray-600 hover:bg-gray-800 hover:text-white transition-colors"
                        >
                            Geri Dön
                        </Button>

                        {/* YENİ: Bilgilendirme Butonu */}
                        <Button 
                            onClick={() => setIsInfoModalOpen(true)}
                            variant="outlined"
                            startIcon={<HelpOutlineIcon />}
                            className="text-teal-400 border-teal-500/30 hover:bg-teal-500/10 hover:border-teal-400 transition-colors"
                        >
                            Nasıl Çalışır?
                        </Button>
                    </div>

                    {/* Sağ Taraf: Başlık */}
                    <div className="text-left md:text-right">
                        <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-indigo-500">
                            Yeni Rota Oluştur
                        </h1>
                        <p className="text-gray-400 text-sm mt-1">Kendi keşif rotanı oluştur ve paylaş!</p>
                    </div>
                </div>

                <form onSubmit={handleRotayiKaydet} className="space-y-8 animate-fadeIn">
                    
                    {/* Yükleme Göstergesi */}
                    {formYukleniyor && (
                        <div className="flex items-center justify-center gap-3 p-4 bg-gray-800 text-teal-400 rounded-lg border border-gray-700 shadow-md animate-pulse">
                            <CircularProgress size={20} className="text-teal-400" />
                            <span className="font-medium">Rota oluşturuluyor...</span>
                        </div>
                    )}

                    {/* 1. Kısım: Genel Bilgiler */}
                    <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 shadow-lg relative overflow-hidden">
                        {/* Dekoratif arka plan detayı */}
                        <div className="absolute top-0 right-0 p-4 opacity-5">
                            <SaveIcon style={{ fontSize: 100 }} />
                        </div>

                        <h2 className="text-xl font-bold text-teal-400 mb-6 border-b border-gray-700 pb-2 flex items-center gap-2">
                            <span className="flex items-center justify-center w-6 h-6 rounded-full bg-teal-500 text-gray-900 text-sm">1</span>
                            Genel Bilgiler
                        </h2>
                        
                        <div className="grid md:grid-cols-2 gap-6 mb-6">
                            <TextField 
                                label="Rota Adı" 
                                placeholder="Örn: Tarihi Yarımada Gezisi"
                                value={rotaAdi} 
                                onChange={(e) => setRotaAdi(e.target.value)} 
                                fullWidth 
                                InputLabelProps={{ shrink: true }} 
                                sx={inputStyles} 
                            />
                            <TextField 
                                label="Ortalama Süre" 
                                placeholder="Örn: 3 Saat, 1 Gün"
                                value={ortalamaSure} 
                                onChange={(e) => setOrtalamaSure(e.target.value)} 
                                fullWidth 
                                InputLabelProps={{ shrink: true }} 
                                sx={inputStyles} 
                            />
                        </div>
                        
                        <TextField 
                            label="Rota Açıklaması" 
                            placeholder="Bu rotada gezginleri neler bekliyor?"
                            value={rotaAciklamasi} 
                            onChange={(e) => setRotaAciklamasi(e.target.value)} 
                            multiline rows={3} 
                            fullWidth 
                            InputLabelProps={{ shrink: true }} 
                            sx={inputStyles} 
                        />

                        <TextField 
                            label="Neler Öğreneceksiniz?" 
                            placeholder="Her satıra bir madde yazın (Enter'a basarak alt satıra geçin)"
                            value={nelerOgreneceksinizText} 
                            onChange={(e) => setNelerOgreneceksinizText(e.target.value)} 
                            multiline rows={3} 
                            fullWidth 
                            className="mt-6"
                            InputLabelProps={{ shrink: true }} 
                            sx={inputStyles} 
                        />

                        <div className="mt-6">
                            <label className="block text-gray-400 text-sm mb-2 font-medium">Kapak Görseli</label>
                            <div className="flex items-center gap-4">
                                <Button component="label" variant="contained" className="bg-gray-700 hover:bg-gray-600 text-white capitalize">
                                    Dosya Seç
                                    <input type="file" hidden accept="image/*" onChange={(e) => setRotaGorseliFile(e.target.files?.[0])} />
                                </Button>
                                {rotaGorseliPreview && <img src={rotaGorseliPreview} alt="Preview" className="h-20 w-32 object-cover rounded-md border border-gray-600 shadow-sm" />}
                            </div>
                        </div>
                    </div>

                    {/* 2. Kısım: Mekan Ekleme */}
                    <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 shadow-lg relative overflow-hidden">
                        <div className="absolute top-0 right-0 p-4 opacity-5">
                            <LocationOnIcon style={{ fontSize: 100 }} />
                        </div>
                        
                        <h2 className="text-xl font-bold text-teal-400 mb-6 border-b border-gray-700 pb-2 flex items-center gap-2">
                             <span className="flex items-center justify-center w-6 h-6 rounded-full bg-teal-500 text-gray-900 text-sm">2</span>
                            Rota Durakları (Mekanlar)
                        </h2>
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                            <div className="flex flex-col">
                                <label className="text-gray-400 text-xs mb-1 ml-1">İl Seçin</label>
                                <select 
                                    className="bg-gray-900 text-white p-3 rounded border border-gray-600 focus:border-teal-500 focus:outline-none transition-colors" 
                                    value={secilenIl} 
                                    onChange={(e) => setSecilenIl(e.target.value)}
                                >
                                    <option value="" className="text-gray-500">İl Seçin...</option>
                                    {iller.map(il => <option key={il.id} value={il.id}>{il.name}</option>)}
                                </select>
                            </div>
                            <div className="flex flex-col">
                                <label className="text-gray-400 text-xs mb-1 ml-1">İlçe Seçin</label>
                                <select 
                                    className="bg-gray-900 text-white p-3 rounded border border-gray-600 focus:border-teal-500 focus:outline-none transition-colors disabled:opacity-50" 
                                    value={secilenIlce} 
                                    onChange={(e) => setSecilenIlce(e.target.value)} 
                                    disabled={!secilenIl}
                                >
                                    <option value="" className="text-gray-500">İlçe Seçin...</option>
                                    {mevcutIlceler.map(ilce => <option key={ilce.id} value={ilce.id}>{ilce.name}</option>)}
                                </select>
                            </div>
                        </div>

                        <Autocomplete
                            freeSolo
                            options={filtreliMekanOnerileri}
                            getOptionLabel={(option) => typeof option === 'string' ? option : (option.ad || '')}
                            value={secilenMekanObj}
                            onChange={(e, newValue) => setSecilenMekanObj(newValue)}
                            inputValue={arananMekanAdi}
                            onInputChange={(e, val) => { setArananMekanAdi(val); if(val !== arananMekanAdi) setSecilenMekanObj(null); }}
                            renderInput={(params) => (
                                <TextField 
                                    {...params} 
                                    label="Mekan Adı Ara veya Yaz" 
                                    fullWidth 
                                    InputLabelProps={{ shrink: true }}
                                    sx={inputStyles} 
                                />
                            )}
                            PaperComponent={({ children }) => (
                                <div className="bg-gray-700 text-white border border-gray-600 mt-1 rounded-md shadow-lg">
                                    {children}
                                </div>
                            )}
                        />
                        
                        <Button 
                            variant="contained" 
                            onClick={handleMekanEkle} 
                            startIcon={<AddCircleOutlineIcon />} 
                            className="mt-4 w-full bg-teal-600 hover:bg-teal-700 py-3 font-semibold"
                        >
                            Listeye Ekle
                        </Button>

                        {/* Eklenen Mekanlar Listesi */}
                        <div className="mt-8">
                            {eklenenMekanlar.length > 0 ? (
                                <ul className="space-y-2">
                                    {eklenenMekanlar.map((mekan, index) => (
                                        <li key={mekan.id} className="flex justify-between items-center bg-gray-900/50 p-4 rounded-lg border border-gray-700 hover:border-teal-500/50 transition-colors">
                                            <div className="flex items-center">
                                                <span className="flex items-center justify-center w-6 h-6 rounded-full bg-teal-500/20 text-teal-400 text-xs font-bold mr-3">
                                                    {index + 1}
                                                </span>
                                                <div>
                                                    <div className="text-white font-medium">{mekan.ad}</div>
                                                    <div className="text-gray-500 text-xs">{mekan.ilce}</div>
                                                </div>
                                            </div>
                                            <IconButton onClick={() => handleMekanKaldir(mekan.id)} size="small" className="text-red-400 hover:text-red-300 hover:bg-red-900/20">
                                                <DeleteOutlineIcon />
                                            </IconButton>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <div className="text-center p-6 text-gray-500 text-sm border border-dashed border-gray-700 rounded-lg bg-gray-900/30">
                                    <div className="mb-2">📍</div>
                                    Henüz mekan eklenmedi. Yukarıdan aratarak rotanıza ekleyebilirsiniz.
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Butonlar */}
                    <div className="flex justify-end gap-4 pt-4 pb-8">
                        <Button 
                            onClick={handleIptal} 
                            variant="outlined" 
                            startIcon={<CancelIcon />}
                            className="border-gray-600 text-gray-400 hover:bg-gray-800 hover:border-gray-500 py-3 px-6"
                        >
                            İptal
                        </Button>
                        <Button 
                            type="submit" 
                            variant="contained" 
                            startIcon={<SaveIcon />} 
                            className="bg-gradient-to-r from-teal-500 to-indigo-600 hover:from-teal-600 hover:to-indigo-700 text-white py-3 px-8 font-bold shadow-lg transform hover:-translate-y-1 transition-all"
                        >
                            Rotayı Kaydet
                        </Button>
                    </div>
                </form>
            </div>

            {/* --- Başarı/Hata Modalı --- */}
            <Modal open={isModalOpen} onClose={handleCloseModal}>
                <Box sx={modalStyle}>
                    <Typography id="modal-title" variant="h6" component="h2" className={`font-bold ${isSuccessModal ? 'text-teal-400' : 'text-red-400'}`}>
                        {modalContent.title}
                    </Typography>
                    <Typography id="modal-description" sx={{ mt: 2, color: 'text-gray-300' }}>
                        {modalContent.message}
                    </Typography>
                    <Button onClick={handleCloseModal} variant="contained" className={`mt-4 w-full ${isSuccessModal ? 'bg-teal-500 hover:bg-teal-600' : 'bg-red-500 hover:bg-red-600'}`}>
                        Tamam
                    </Button>
                </Box>
            </Modal>

            {/* --- YENİ: Bilgilendirme Modalı --- */}
            <Modal open={isInfoModalOpen} onClose={() => setIsInfoModalOpen(false)}>
                <Box sx={infoModalStyle}>
                    <div className="flex justify-between items-center mb-4 pb-2 border-b border-gray-700">
                        <Typography variant="h6" className="font-bold text-teal-400 flex items-center gap-2">
                            <HelpOutlineIcon /> Rota Oluşturma Rehberi
                        </Typography>
                        <IconButton onClick={() => setIsInfoModalOpen(false)} className="text-gray-400 hover:text-white">
                            <CloseIcon />
                        </IconButton>
                    </div>
                    
                    <div className="space-y-6 text-gray-300">
                        <div className="flex gap-4">
                            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-teal-900/50 text-teal-400 flex items-center justify-center font-bold border border-teal-500/30">1</div>
                            <div>
                                <h4 className="font-bold text-white mb-1">Rotanızı Tanımlayın</h4>
                                <p className="text-sm text-gray-400">Rotanıza dikkat çekici bir isim verin ve gezginlerin ne kadar süre ayırması gerektiğini belirtin. Kapak görseli eklemek rotanızı öne çıkarır.</p>
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-teal-900/50 text-teal-400 flex items-center justify-center font-bold border border-teal-500/30">2</div>
                            <div>
                                <h4 className="font-bold text-white mb-1">Durakları Ekleyin</h4>
                                <p className="text-sm text-gray-400">İl ve ilçe seçerek başlayın. Ardından mekan adını yazıp aratın. Listeden seçtiğiniz mekanı <strong>"Listeye Ekle"</strong> butonuyla rotanıza dahil edin.</p>
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-teal-900/50 text-teal-400 flex items-center justify-center font-bold border border-teal-500/30">3</div>
                            <div>
                                <h4 className="font-bold text-white mb-1">Kontrol ve Kayıt</h4>
                                <p className="text-sm text-gray-400">Eklediğiniz mekanları sıralı listede görebilirsiniz. Yanlış eklediğiniz mekanları çöp kutusu ikonu ile silebilirsiniz. Her şey hazırsa <strong>"Rotayı Kaydet"</strong> butonuna basın.</p>
                            </div>
                        </div>
                    </div>

                    <div className="mt-8 pt-4 border-t border-gray-700 text-center">
                        <Button 
                            onClick={() => setIsInfoModalOpen(false)} 
                            variant="contained" 
                            className="bg-gray-700 hover:bg-gray-600 px-8"
                        >
                            Anladım, Başlayalım
                        </Button>
                    </div>
                </Box>
            </Modal>
        </div>
    );
};

export default YeniRotaOlusturSayfasi;